<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <LogoComponent :class="$style.logo" />
</template>

<script setup lang="ts">
  import LogoComponent from 'assets/svg/yogenLogo.svg'
</script>
<style module>
  .logo {
    fill: transparent;
    width: 70px;
    height: 40px;
  }
</style>
